import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import resetCourse from 'api/administration/courses/Reset'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

async function reset(courseId: number, userId: number) {
  return await resetCourse(userId, courseId)
}

function* courseResetEffectSaga(action: any) {
  try {
    const {
      payload: { courseId, userId },
    } = action
    yield call(reset, courseId, userId)
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
    yield put(fromActions.Actions.participantGetCourses(userId))
  } catch (error) {
    ErrorToast(I18n.t(`administration.toastMessages.genericError`))
    console.log('error: ', error)
  }
}

export function* courseResetWatcherSaga() {
  yield takeLatest(fromActions.RESET_COURSE, courseResetEffectSaga)
}
